
import Vue from 'vue'
import Component from 'vue-class-component'

import PasswordValidator from '@/components/admin/users/password-validator.vue'
import { changePassword } from '@/components/admin/users/users.service'

@Component({ components: { PasswordValidator } })
export default class ChangePassword extends Vue {
  async handlePasswordChange(payload: { newPassword: string }) {
    try {
      const response = await changePassword({
        currentPassword: '', // Not needed since we're using a token, but the API expects it
        newPassword: payload.newPassword,
        userId: this.getUserIdFromToken()
      })
      // const response = await axios.post('/api/user/change-password', {
      //   userId: this.getUserIdFromToken(),
      //   newPassword: payload.newPassword
      // })

      const session = response.data

      // Save new JWT
      localStorage.setItem('token', session.token)

      // Redirect to dashboard
      this.$router.push('/login')
      localStorage.clear()
    } catch (error) {
      // Send error back to child component
      const form = this.$refs.passwordForm as any
      // if (form) {
      //   form.error = error.response?.data?.Errors || 'Error changing password'
      // }
    }
  }

  private getUserIdFromToken(): number {
    const token = localStorage.getItem('token')
    if (!token) return 0

    const payload = JSON.parse(atob(token.split('.')[1]))
    return parseInt(payload.nameid)
  }
}
